import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/auth.css';

export default function ActivateAccount() {
  return (
    <div className="wp-auth">
      <header className="wp-auth__header">
        <Link to="/" className="wp-auth__logo-link" aria-label="Woss Publishing">
          <img src="/woss-publishing-assets/images/woss-publishing-logo-white.svg" alt="Woss Publishing" className="wp-auth__logo" />
        </Link>
        <Link to="/" className="wp-auth__back-link">← BACK TO WOSS PUBLISHING</Link>
      </header>
      <main className="wp-auth__main">
        <div className="wp-auth__card">
          <p className="wp-auth__eyebrow">Account Activation</p>
          <h1 className="wp-auth__heading">Activate your account</h1>
          <p className="wp-auth__sub">
            Your activation link is being processed. If this page persists,
            the link may have expired. Please contact your Woss Publishing representative.
          </p>
          <div className="wp-auth__links">
            <Link to="/auth/login" className="wp-auth__link">Go to sign-in</Link>
          </div>
        </div>
      </main>
      <footer className="wp-auth__footer">
        &copy; {new Date().getFullYear()} Woss Publishing. All rights reserved.
      </footer>
    </div>
  );
}
